export const GET_SUPPLIERTYPE_REQUEST = 'GET_SUPPLIERTYPE_REQUEST';
export const GET_SUPPLIERTYPE_DATA = 'GET_SUPPLIERTYPE_DATA';
export const GET_SUPPLIERTYPE_ERROR = 'GET_SUPPLIERTYPE_ERROR';

export const CREATE_SUPPLIERTYPE_REQUEST = 'CREATE_SUPPLIERTYPE_REQUEST';
export const CREATE_SUPPLIERTYPE_DATA = 'CREATE_SUPPLIERTYPE_DATA';
export const CREATE_SUPPLIERTYPE_ERROR = 'CREATE_SUPPLIERTYPE_ERROR';

export const UPDATE_SUPPLIERTYPE_REQUEST = 'UPDATE_SUPPLIERTYPE_REQUEST';
export const UPDATE_SUPPLIERTYPE_DATA = 'UPDATE_SUPPLIERTYPE_DATA';
export const UPDATE_SUPPLIERTYPE_ERROR = 'UPDATE_SUPPLIERTYPE_ERROR';

export const DELETE_SUPPLIERTYPE_REQUEST = 'DELETE_SUPPLIERTYPE_REQUEST';
export const DELETE_SUPPLIERTYPE_DATA = 'DELETE_SUPPLIERTYPE_DATA';
export const DELETE_SUPPLIERTYPE_ERROR = 'DELETE_SUPPLIERTYPE_ERROR';


